// src/ChevronRightIcon.tsx
import { jsx } from "react/jsx-runtime";
var ChevronRightIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m9 18 6-6-6-6" })
  }
);
var ChevronRightIcon_default = ChevronRightIcon;

export {
  ChevronRightIcon_default
};
